import { render, staticRenderFns } from "./brandproduct.vue?vue&type=template&id=651579fe&scoped=true&"
import script from "./brandproduct.vue?vue&type=script&lang=js&"
export * from "./brandproduct.vue?vue&type=script&lang=js&"
import style0 from "./brandproduct.vue?vue&type=style&index=0&id=651579fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651579fe",
  null
  
)

export default component.exports